import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobConfig } from '@recruitee/async-job';
import { NotificationStyle } from '@recruitee/user-interface';

@Injectable()
export class BulkCompaniesCreateInvitationsAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BulkCompaniesCreateInvitations;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.bulk_companies_create_invitations.title.success',
      progress: 'app.async_jobs.bulk_companies_create_invitations.title.progress',
    },
  };

  public readonly skipNotificationMessages = false;
  public readonly skipProgressBar = false;
  public readonly workingNotificationStyle = NotificationStyle.InProgress;
}
